import { createAsyncThunk } from '@reduxjs/toolkit'
import { postData } from '../../shared/api/api'
import { CheckZonesResponse, ZoneRequest } from './types'
import { APIResponseError } from '../../shared/types'

export const checkZones = createAsyncThunk<
  CheckZonesResponse,
  ZoneRequest,
  { rejectValue: APIResponseError }
>('Zones/post', async (payload: ZoneRequest, { rejectWithValue }) => {
  try {
    const response = await postData<CheckZonesResponse>('/zones/check', payload)
    return response
  } catch (error: any) {
    const status = error.response?.status

    // TODO: fix error response
    // if (status === 404) {
    //   return rejectWithValue({
    //     status: 404,
    //     message: 'No zones found for this location',
    //   })
    // }

    return rejectWithValue({
      status: status ?? 500,
      message:
        error.response?.data?.message ??
        error.message ??
        'Failed to check zones',
    })
  }
})
